import './style.less'

export const Logo: React.FC = () => {
  return (
        <div className="logo">
            <img src="/logo.svg" alt="Syniva" style={{ width: '90%' }} />
        </div>
  )
}
